import appStoreButton from '../../components/Placeholder/app-store-white.png';
import * as React from 'react';
import { Placeholder, PlaceholderContent } from '../../components/Placeholder';
import styled from 'styled-components';
import SvgIcon from '../../components/SvgIcon';

export const MobilePlaceholderContainer = styled(Placeholder)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`;

export const MobilePlaceholder = () => {
  return (
    <MobilePlaceholderContainer>
      <PlaceholderContent>
        <SvgIcon iconName={'eggIcon'} iconWidth={300} iconHeight={200} />
        <p>
          Morning Pages is currently not optimized for mobile screens, but it is already available on iPhone and iPad!
        </p>
        <a href="https://itunes.apple.com/us/app/morningpages-daily-journal/id1223874080?mt=8" target="_blank">
          <img src={appStoreButton} alt="AppStore" width={144} height={48} />
        </a>
      </PlaceholderContent>
    </MobilePlaceholderContainer>
  );
};



// WEBPACK FOOTER //
// ./src/containers/App/MobilePlaceholder.tsx